import React, { useState } from 'react';
import cx from 'classnames';
import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/ingredients/LinkAsButton/LinkAsButton';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';
import { Badge } from '@johnlewispartnership/wtr-ingredients/ingredients/Badge';
import { type Banner } from 'api/definitions/adtech/types';
import { useAdtechObserver } from 'components/adtech/use-adtech-observer';
import { sendAdTechEvent } from 'analytics/gtmServerFunctions';
import { getBannerUrl } from 'utils/adtech/generate-banner-link';
import { type CitrusProduct } from 'utils/adtech/transform-searchresult-to-tradingcell-props';
import styles from './styles.scss';

export const AdtechCard = ({
  banner: { id, textArea, image, products, marketingBadge, tracking },
  className,
}: { banner: Banner } & Pick<React.HTMLAttributes<HTMLDivElement>, 'className'>) => {
  const [isLoaded, setIsLoaded] = useState(!image.src);

  const callbackRef = useAdtechObserver(id, tracking);

  return (
    <div ref={callbackRef} className={cx(className, { [styles.ad]: isLoaded })}>
      <img
        src={image.src}
        alt=""
        style={{ display: isLoaded ? 'block' : 'none' }}
        onLoad={() => setIsLoaded(true)}
      />
      {isLoaded && (
        <>
          {marketingBadge && <Badge className={styles.badge} text={marketingBadge} />}
          <h3>
            <span className={styles.promo}>{textArea.offerHeading}</span> {textArea.heading}
          </h3>
          <Typography>{textArea.subheading}</Typography>
          <LinkAsButton
            href={getBannerUrl(textArea.link.url, products as CitrusProduct[])}
            width="full"
            aria-label={textArea.link.altText}
            target={textArea.link.isExternalLink ? '_blank' : undefined}
            rel={textArea.link.isExternalLink ? 'noopener noreferrer' : undefined}
            onClick={() => {
              sendAdTechEvent({
                eventType: 'click',
                sponsorshipId: id,
                trackingUrls: tracking.clickUrls,
                vendor: tracking.vendor,
              });
            }}
          >
            {textArea.link.text || 'Shop Now'}
          </LinkAsButton>
        </>
      )}
    </div>
  );
};
